var _a, _b, _c, _d;
export const TITLE = "Zeplin";
export const ADDON_ID = "zeplin";
export const PARAM_KEY = "zeplinLink";
export const PANEL_ID = `${ADDON_ID}/panel`;
export const ZEPLIN_TOKEN = process.env.STORYBOOK_ZEPLIN_TOKEN;
export const PARENT_ORIGIN = (_a = process.env.STORYBOOK_ZEPLIN_PARENT_ORIGIN) !== null && _a !== void 0 ? _a : "https://app.zeplin.io";
export const ZEPLIN_API_URL = (_b = process.env.STORYBOOK_ZEPLIN_API_URL) !== null && _b !== void 0 ? _b : "https://api.zeplin.dev";
export const ZEPLIN_WEB_BASE = (_c = process.env.STORYBOOK_ZEPLIN_WEB_BASE) !== null && _c !== void 0 ? _c : "https://app.zeplin.io";
export const ZEPLIN_APP_BASE = (_d = process.env.STORYBOOK_ZEPLIN_APP_BASE) !== null && _d !== void 0 ? _d : "zpl:";
